import type { UserItemList } from "@services/users/list/type";

export const UsersColumns: Array<{
  id: keyof UserItemList;
  label: string;
}> = [
  { id: "username", label: "Nome" },
  { id: "email", label: "E-mail" },
  { id: "role", label: "Permissão" },
  { id: "lastLogin", label: "Último Login" },
] as const;
